import React from "react";
import './ConsentForm.css';

const ConsentForm = ({ 
  date = "CM Disb Date", 
  place = "branch Name",
  customerName = "Customer name",
  secondName = "Second Name",
  customerAddress = "Customer Address",
  loanAmount = "Loan Amount",
  loanAmountInWords = "Rupees in Words only",
  mobileNumber = "9876543210",
  aadhaarNo = "569825821023"
}) => {
  return (
    <div className="consent-form" style={{ marginTop: '20px', marginBottom: '20px' }}>
      <div className="header">
        <h1>Consent Form for Direct Loan Disbursement to Goldsmith</h1>
        <h2>(For Jewel Purchase Loan - Borrower's Declaration)</h2>
      </div>

      <div className="meta-info">
        <p>Date: {date}</p>
        <p>Place: {place}</p>
      </div>

      <div className="recipient-address">
        <p>To</p>
        <p>Vetrivikas Capital Trust</p>
        <p>25, Arunachalashwara 3rd Cross Street</p>
        <p>HMS Colony, 1st Main Road</p>
        <p>Kokklappi, Madurai -625016.</p>
      </div>

      <div className="subject">
        <p>Subject: Consent for Direct Disbursement of Loan Amount to Vetrivikas-Approved Goldsmith</p>
      </div>

      <div className="content">
        <p>
          I, Mr./Ms. <strong>{customerName}</strong>, Nominee Name {secondName} residing at <strong>{customerAddress}</strong>, have applied for a Jewel Purchase Loan of Vetrivikas Capital Trust.
        </p>
        <p>
          I hereby provide my full consent to Vetrivikas Capital Trust to directly disburse the sanctioned loan amount of ₹ <strong>{loanAmount} ({loanAmountInWords})</strong> to the account of a Goldsmith Sethuraman jewellers and approved by Vetrivikas Capital Trust, against the purchase of gold ornaments on my behalf.
        </p>

        <p>I understand and agree to the following terms:</p>
        <ol>
          <li>The gold ornaments will be procured from a trusted and empanelled Goldsmith/Supplier as identified by Vetrivikas Capital Trust.</li>
          <li>I agree that the selected Goldsmith will provide the gold as per the agreed standards of purity and weight and will issue proper invoice/bill in my name.</li>
          <li>I authorize Vetrivikas Capital Trust to complete the payment directly to the Goldsmith's account. ___________________________________________________________________________________________________________________________________________________.</li>
          <li>I understand that once the loan amount is disbursed, I shall be liable to repay the entire loan as per the loan agreement.</li>
          <li>I understand and agree that the gold ornaments will be handed over to me only after the successful completion of the loan, as per the terms and conditions agreed in the loan agreement.</li>
        </ol>

        <p>This consent is provided voluntarily and with full understanding of the terms.</p>
      </div>

      <div className="borrower-details">
        <h3>Borrower Details</h3>
        <ul>
          <li>Name: {customerName}</li>
          <li>Mobile Number: {mobileNumber}</li>
          <li>Aadhaar No: {aadhaarNo}</li>
          <li className="signature">Signature of Borrower: ______________________</li>
        </ul>
      </div>
    </div>
  );
};

export default ConsentForm;